//import banner from "../../assets/images/banner.png";
import ApplyNowButton from "../ApplyNowButton";

const BannerSection = () => {
  return (
    <section className="w-full bg-[url(../../assets/images/banner.png)] flex justify-center relative">
      <div className="w-4/5 py-12">
        <h3 className="text-white text-3xl font-bold text-center">
          Sen de Geleceğin Ray’ında Genç Yetenek Programı ile <br />
          ’’Burada her şey yolunda!’’ demek için
        </h3>
      </div>
      <div className="absolute flex justify-center" style={{ bottom: "-28px" }}>
        <ApplyNowButton />
      </div>
    </section>
  );
};

export default BannerSection;
